/* global document */

import smoothscrollPolyfill from 'smoothscroll-polyfill';

import {
	navMobile,
	mapScreen,
	form,
	loginSlip,
	editlist,
	placeSingle,
	storyGallery,
	offcanvasPanel,
	dashSearch
} from '../../components/index';

smoothscrollPolyfill.polyfill();

navMobile.init();
mapScreen.init();
form.init();
loginSlip.init();
editlist.init();
placeSingle.init();
storyGallery.init();
offcanvasPanel.init();
dashSearch.init();
